import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetRecievedOrdersSlice = createSlice({
    name: "getRecievedOrders",
    initialState,
    reducers: {
        getRecievedOrdersRequest(state) {
            state.loading = true;
        },
        getRecievedOrdersRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getRecievedOrdersRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getRecievedOrdersRequest,
    getRecievedOrdersRequestSuccess,
    getRecievedOrdersRequestError,
} = GetRecievedOrdersSlice.actions;

export default GetRecievedOrdersSlice.reducer;
